// import React from "react";
// import s1 from "../assets/s1.png";
// import vector from "../assets/Vector.png";
// import v from "../assets/v.png";
// import f1 from "../assets/f1.png";
// import f2 from "../assets/f2.png";
// import PhoneHeader from "./PhoneHeader";

// const UPIMicroATM = () => {
//   const data = [
//     {
//       title: "Financial Inclusion",
//       text: "Brings banking to remote or rural areas without branches."
//     },
//     {
//       title: "Secure & Reliable",
//       text: "Uses Aadhaar authentication, reducing fraud risk."
//     },
//     {
//       title: "No Card Required",
//       text: "Works without debit/credit cards or smartphones in some cases."
//     },
//     {
//       title: "Commission for Agents",
//       text: "Agents / BCs can earn commission on each transaction."
//     }
//   ];
//   return (
//     <>
//       <PhoneHeader title="UPI & Micro ATM" className="d-md-none d-block" />
//       <div className="container-fluid d-md-block d-none">
//         <div className="text-center top-heading section">
//           <h1>  </h1>
//         </div>
//       </div>
//       <div className="container">
//         <div className="row section align-items-center">
//           <div className="col-12 col-md-6 mb-3 mb-md-0">
//             <h1>
//               <strong>Overview</strong>
//             </h1>
//           </div>

//           <div className="col-12 col-md-6">
//             <p>
//               <strong style={{ color: "#FF7A60", fontSize: "26px" }}>O</strong>
//               ur platform supports digital payments via UPI along with cash
//               access through Micro ATMs — giving customers flexibility to go
//               cashless or withdraw cash conveniently. Based on PaymentHub’s
//               service model
//             </p>
//           </div>
//         </div>

//         <div className="section">
//           <img src={s1} className="w-100" />
//         </div>

//         <div className="row section justify-content-center">
//           <div className="col-12 col-md-6 mb-4">
//             <div
//               className="py-4 px-5"
//               style={{ backgroundColor: "#FFDED3", borderRadius: "20px" }}
//             >
//               <h2 className="mb-md-5 mb-3" style={{ fontWeight: "700" }}>
//                 UPI Features
//               </h2>

//               <div className="mb-3 d-flex align-items-center">
//                 <img src={vector} />
//                 <span>
//                   Instant peer-to-peer fund transfers.
//                 </span>
//               </div>

//               <div className="mb-5 d-flex align-items-center">
//                 <img src={vector} />
//                 <span>
//                   QR based payments for merchants.
//                 </span>
//               </div>

//               <img src={f1} className="mt-4 mb-4 d-block mx-auto w-100" />
//             </div>
//           </div>

//           <div className="col-12 col-md-6 mb-4">
//             <div
//               className="py-4 px-5"
//               style={{ backgroundColor: "#E0FBFF", borderRadius: "20px" }}
//             >
//               <h2 className="mb-md-5 mb-3" style={{ fontWeight: "700" }}>
//                 Micro ATM Features
//               </h2>

//               <div className="mb-3 d-flex align-items-center">
//                 <img src={v} />
//                 <span>
//                   Cash withdrawal using any bank account.
//                 </span>
//               </div>

//               <div className="mb-5 d-flex align-items-center">
//                 <img src={v} />
//                 <span>
//                   Balance enquiry and mini statement support.
//                 </span>
//               </div>

//               <img src={f2} className="mt-4 mb-4 d-block mx-auto w-100" />
//             </div>
//           </div>
//         </div>

//         {/* benefits */}
//         <div className="section d-none d-md-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="benefits-wrapper position-relative">
//             <div className="benefit"></div>
//             <div className="center-line"></div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">
//                     Expand your financial service offering.
//                   </h5>
//                   <p className="text-start">
//                     One-stop bill payment portal for multiple services.
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6"></div>
//               <div className="col-6">
//                 <div className="benefit-card-1">
//                   <h5 className="fw-bold mb-3">
//                     Earn commission on cash withdrawal, balance check
//                     transactions.
//                   </h5>
//                   <p>Backed by established payment network.</p>
//                 </div>
//               </div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">
//                     Provide UPI payment options to your customers, boosting
//                     sales.
//                   </h5>
//                   <p className="text-start">
//                     Agents can facilitate bill payments and earn fees. (Modelled
//                     like PaymentHub)
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>
//           </div>
//         </div>

//         <div className="section d-md-none d-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="row justify-content-center">
//             {data.map((item, index) => (
//               <div className="col-12 mb-3" key={index}>
//                 <div className="benefit-box text-center p-4">
//                   <h5 className="mb-2" style={{fontWeight:"700"}}>{item.title}</h5>
//                   <p className="mb-0">{item.text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default UPIMicroATM;
import React from "react";
import s1 from "../assets/s1.png";
import solution from "../assets/solution.png";
import solution1 from "../assets/exchange.png";
import solution2 from "../assets/neural.png";
import solution3 from "../assets/cash-withdrawal.png";
import solution4 from "../assets/files.png";
import solution5 from "../assets/shield.png";
import PhoneHeader from "./PhoneHeader";
import benfits from "../assets/benfites.jpg";

const Upiatm = () => {
  return (
    <>
      <PhoneHeader title="AEPS Service" className="d-md-none d-block" />

      {/* <div className="container-fluid d-md-block d-none">
        <div className="text-center top-heading section">
          <h1>AEPS Service</h1>
        </div>
      </div> */}
      <div className="container space">
        <div className="text-center top-heading section">
          <h1 className="mb-0">UPI ATM</h1>
        </div>
        <div className="row section align-items-center">
          <div className="col-12 col-md-7">
            <div className="">
              <h1>
                <strong>Overview</strong>
              </h1>
            </div>
            <p>
              {/* <strong style={{ color: "#FF7A60", fontSize: "26px" }}>U</strong> */}
              UPI ATM is a modern, card-less cash withdrawal solution that allows
              users to withdraw money using the UPI app directly from any
              supported ATM or Micro-ATM device. It eliminates the need for
              physical debit cards and provides faster, safer, and more
              convenient access to cash. When integrated with an AEPS payment
              system, UPI ATM services expand the range of digital and
              cash-based financial solutions offered to customers.
            </p>
            <ul class="list-unstyled mb-4 mb-md-0">
              <h5 className="fw-bold mt-2 mb-3">How UPI ATM Works</h5>
              <li className="mb-2">
                • Simply scan the ATM QR code using the UPI app (like Google
                Pay, Paytm, BHIM, etc.)
              </li>
              <li className="mb-2">
                • Enter the withdrawal amount, and confirm the transaction with
                their UPI PIN.
              </li>
              <li className="mb-2">
                • Cash is dispensed instantly—no card required.
              </li>
              {/* <li class="fw-bold mb-2">• No need for ATM cards or PINs</li>
              <li class="fw-bold mb-2">
                • Easy setup with minimal infrastructure
              </li> */}
            </ul>
          </div>
          <div className="col-12 col-md-5 mb-3 mb-md-0">
            <div className="">
              <img src={s1} className="w-100 m-auto img-holl" />
            </div>
          </div>
        </div>

        <div
          className="row section p-md-4 px-1 pt-5 pb-4"
          style={{ backgroundColor: "#FFF6F3", padding: "36px" }}
        >
          <div className="col-12 col-md-6 m-auto text-center d-none d-md-block">
            <img src={solution} alt="solution" className="img-fluid" />
          </div>

          <div className="col-12 col-md-6 m-auto">
            <h2 className="mb-md-5 mb-3 center" style={{ fontWeight: "700" }}>
              Key Features of UPI ATM
            </h2>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution5} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Card-less Cash Withdrawals
                </h6>
                <p className="mb-0">
                  Users no longer need to carry physical debit cards, reducing
                  the risk of card loss or fraud.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution1} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Instant & Secure Transactions
                </h6>
                <p className="mb-0">
                  QR-based withdrawal and UPI PIN authentication offer a highly
                  secure, encrypted process.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution2} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Faster Cash Access
                </h6>
                <p className="mb-0">
                  Avoids card jams, OTP delays, and traditional ATM
                  issues—resulting in quick and smooth withdrawals.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution3} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Wide UPI App Support
                </h6>
                <p className="mb-0">
                  Works with major UPI applications for maximum user
                  convenience.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution4} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Lower Transaction Risk
                </h6>
                <p className="mb-0">
                  No card skimming, PIN theft, or shoulder-surfing threats.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="section key-features align-items-center py-md-5 p-4">
          {/* HEADING */}
          <h2 className="fw-bold text-center mb-4">
            Benefits for Retailers / Distributors
          </h2>

          <div className="row">
            {/* IMAGE */}
            <div className="col-12 col-md-5  text-center mb-4 mb-md-0">
              <img
                src={benfits}
                alt="Key Features"
                className="img-fluid img-holl"
                style={{ maxWidth: "100%", width: "100%" }}
              />
            </div>

            {/* FEATURE LIST */}
            <div className="col-12 col-md-7 m-auto">
              <ul className="list-unstyled mx-auto">
                <li className=" mb-3">
                  • Increase customer footfall by offering modern cash
                  withdrawal services
                </li>
                <li className=" mb-3">
                  • Earn attractive commissions on every UPI ATM transaction
                </li>
                <li className=" mb-3">
                  • Reduce dependency on biometric devices for withdrawals
                </li>
                <li className=" mb-3">
                  • Cater to both Aadhaar-based and UPI-based customers
                </li>
                <li className="">
                  • Boost business credibility with advanced digital payment
                  solutions{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Upiatm;
